<!-- 采购结算数据操作 -->
<template>
    <div>
        <purchaseListOrderTemplate ref="purchaseListOrderTemplate"></purchaseListOrderTemplate>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                    <el-form class="baseForm" :show-message="false" id="mainInfo" label-width="120px" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                        <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">

                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                          :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <el-date-picker class="form_codition" v-if="formOneValue.entityField == 'dpsmDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期"
                                                                format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                                                <df-date :isdisabled="formOneValue.isChange == 0" :isShowLong="false" v-else-if="formOneValue.fieldType == 'date'"
                                                         v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-input v-else-if="formOneValue.entityField == 'smName'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    </el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'salesName'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    </el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'opmName'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    </el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.entityField == 'coName'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="(formOneValue.isChange == 0 || dataActionBox.actionType == 2) || (sendDataInfo.psSettlerInvoice.length > 0 && (tableType == 0||tableType==3)) || (sendDataInfo.psSettleInvoiceDetail.length > 0 && (tableType == 1 || tableType == 2))">
                                                    </el-button>
                                                </el-input>
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                          :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                    </el-button>
                                                </el-input>
                                                <!-- 使用预付金额 -->
                                                <input class="newInput" @change="setPreMpney" @keyup.enter="nextFocus(formOneKey)" v-else-if="formOneValue.entityField == 'preMoney'" :disabled="formOneValue.isChange == 0"
                                                       v-model.trim="sendDataInfo[formOneValue.entityField]" />
                                                <el-input v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2" ref="baseForm">
                                            <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                          v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <span v-if="formOneValue.fieldType == 'date'">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                    }}</span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>

                                    <!-- 明细信息 -->
                                    <div>
                                        <div class="flex" id="operateBtn">
                                            <el-radio-group v-model="tableType" @change="calculateTotal" :disabled="dataActionBox.actionType == 2">
                                                <el-radio-button :label="0">按单据结算</el-radio-button>
                                                <el-radio-button :label="1">按明细结算</el-radio-button>
                                                <el-radio-button :label="2">实销实结</el-radio-button>
                                                <el-radio-button :label="3" v-if="invoiceShow">费用登记结算</el-radio-button>
                                            </el-radio-group>
                                            <div style="margin-left: 10px" v-if="dataActionBox.actionType != 2">
                                                <el-button type="primary" size="mini" @click="extract('sendDataInfo')">提取</el-button>
                                                <el-button v-if="invoiceShow" @click="openSearch(8820873997127713, 0, '', '')" size="mini" type="primary">提取对账单</el-button>
                                                <el-button v-if="invoiceShow" @click="openSearch(8820873997127716, 0, '', '')" size="mini" type="primary">提取费用登记</el-button>
                                                <el-button v-if="tabForm[0].isExtract == 1" @click="openExtSearch()" size="mini" type="primary">提取外部订单</el-button>
                                                <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                                </el-button>
                                            </div>
                                        </div>
                                        <el-table size="mini" v-show="tableType == 0||tableType==3" ref="mxTableRef1" :row-class-name="rowClassName1" :row-style="rowStyle" @row-click="clickEvent1"
                                                  @selection-change="handleSelectionChange1" :data="sendDataInfo.psSettlerInvoice" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="80">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                             v-for="(formOneValue, formOneKey) in djForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <el-input @input="calculateTotal" :ref="formOneValue.entityField" @keyup.enter.native="tableNextFocus1(formOneValue.focusField, scope.$index)"
                                                              v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2" :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance"
                                                              :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0" type="number" v-model.trim="sendDataInfo.psSettlerInvoice[scope.$index][formOneValue.entityField]"
                                                              :maxlength="$store.state.inputLength"></el-input>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.psSettlerInvoice[scope.$index][formOneValue.riftField])">
                                                            {{
                                                                sendDataInfo.psSettlerInvoice[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <span v-else>{{
                                                        sendDataInfo.psSettlerInvoice[scope.$index][formOneValue.entityField]
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-table size="mini" v-show="tableType == 1 || tableType == 2" ref="mxTableRef2" :row-class-name="rowClassName2" :row-style="rowStyle" @row-click="clickEvent2"
                                                  @selection-change="handleSelectionChange2" :data="sendDataInfo.psSettleInvoiceDetail" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="80">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDataIndex1" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                             v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <input class="newInput" @input="calculateTotal" :ref="formOneValue.entityField" @keyup.enter="tableNextFocus2(formOneValue.focusField, scope.$index)"
                                                           v-if="formOneValue.entityField == 'settleCount' && dataActionBox.actionType != 2" :min="scope.row.oldBalancenum > 0 ? 0 : scope.row.oldBalancenum"
                                                           :max="scope.row.oldBalancenum > 0 ? scope.row.oldBalancenum : 0" type="number"
                                                           v-model.trim="sendDataInfo.psSettleInvoiceDetail[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                                                    <input class="newInput" @input="toMoney(scope.$index)" :ref="formOneValue.entityField" @keyup.enter="tableNextFocus2(formOneValue.focusField, scope.$index)"
                                                           v-else-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2" :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance"
                                                           :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0" type="number"
                                                           v-model.trim="sendDataInfo.psSettleInvoiceDetail[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.psSettleInvoiceDetail[scope.$index][formOneValue.riftField])">
                                                            {{
                                                                sendDataInfo.psSettleInvoiceDetail[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <span v-else>{{
                                                        sendDataInfo.psSettleInvoiceDetail[scope.$index][formOneValue.entityField]
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" :top="'10px'">
            <SearchSchemeMultiple v-if="seId == '8820873997127713'" ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <SearchScheme v-else :oneFlag="oneFlag" ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span v-if="seId == '8820873997127713'" slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" :top="'10px'">
            <SearchSchemeMultiple v-if="tableType == 1 || tableType == 2" ref="searchSchemeMultiple" @selection="selectClick" :id="searchId" :parentData="parentData" :parentSearchData="parentSearchData1"
                                  @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span v-if="tableType == 1 || tableType == 2" slot="footer" class="dialog-footer">
                <span>合计金额：</span>
                <span style="color: red;margin-right: 10px;">￥{{ money }}</span>
                <el-button @click="DialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
            <ExtractionPurPaymentApplyJS :isMoney="true" :isMoneyType="'totalMoney'" v-else :extractParamsData="extractParamsData" :parentData="parentData" :id="553755277398016" ref="ExtractionPurPaymentApplyJS"
                                         :invoiceExtractData="parentSearchData1" @invoiceExtractMethods="getSelect" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :modal-append-to-body='true' :append-to-body="true" width="80%" top="1vh">
            <ExtractSettleapply ref="ExtractSettleapply" :isSell="false" :detailTableColumn="mxForm" @TranData="getDataByChen" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :close-on-click-modal="false" :append-to-body="true" custom-class="check-credit-dialog" :modal="true" :lock-scroll="false">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import SearchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
import ExtractSettleapply from "../byComponents/ExtractSettleapply.vue";
import ExtractionPurPaymentApplyJS from "../byComponents/ExtractionPurPaymentApplyJS.vue";
import purchaseListOrderTemplate from "@/components/purchaseListOrderTemplate.vue";
export default {
    name: 'psAccountSettlementApplyAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        SearchSchemeMultiple,
        ExtractSettleapply,
        ExtractionPurPaymentApplyJS,
        purchaseListOrderTemplate
    },
    data() {
        //这里存放数据
        return {
            invoiceShow: false,
            extractParamsData: {},
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {},
            selectedDataIndex: 0,
            selectedDataIndex1: 0,
            tableType: 0,
            sendDataInfo: {},
            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            detailsBox: {
                status: false,
                type: 0,
                title: "新增" || "修改",
            },
            editDateilsIndex: "",
            exId: "",
            seId: "",
            dialogTitle: "",
            seWidth: "",
            ppId: "dpsmId",
            exTitle: "",
            seTitle: "",
            exWidth: "",
            DialogVisible: false,
            DialogVisible1: false,
            DialogExtract: false,
            showDialog: false,
            dialogList: [],
            newFormDataList: [],
            seType: '',
            form: [],
            smId: '',
            parentSearchData: {
                smId: ''
            },
            parentSearchData1: {
                smId: '',
                coId: '',
                opmId: '',
                salesId: '',
                depId: ''
            },
            parentData: {
                type: "",
                type1: "",
                list: []
            },
            searchId: '',
            mxHeight: 0,
            isBuyer: 0,
            tabForm: [],
            djForm: [],
            mxForm: [],
            footForm: [],
            nosField: '',
            sField: '',
            fField: '',
            selectedRow: [], // 当前已选择行
            selectedRow2: [], // 当前已选择行
            oldTime: 0,
            money: 0,//合计金额
            oneFlag: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.smName": {
            // smName
            handler: function (newValue, oldValue) {

                if (newValue == '') {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.sbiName = "";
                    this.sendDataInfo.sbiNumber = "";
                    this.sendDataInfo.sbiId = "";
                    this.sendDataInfo.sbiCode = "";

                }
            },
            deep: true,
        },
        "sendDataInfo.payMoney": {
            handler: function (newValue, oldValue) {
                if (new Date().getTime() - this.oldTime > 1000)
                    this.setMoney(this.tabForm[0].jurconfigform);
                this.oldTime = new Date().getTime();
            },
            deep: true,
        },
        "sendDataInfo.preMoney": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
            },
            deep: true,
        },
        "sendDataInfo.totalMoney": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
            },
            deep: true,
        },
        "sendDataInfo.psSettlerInvoice": {
            handler: function (newValue, oldValue) {
                if (this.tableType == 0 || this.tableType == 3) {
                    var sum = 0
                    if (newValue.length > 0) {
                        newValue.forEach(item => {
                            sum += Number(item.settleMoney)
                        })
                    }
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                }
            },
            deep: true,
        },
        "sendDataInfo.psSettleInvoiceDetail": {
            handler: function (newValue, oldValue) {
                if (this.tableType == 1 || this.tableType == 2) {
                    var sum = 0
                    if (newValue.length > 0) {
                        newValue.forEach(item => {
                            sum += Number(item.settleMoney)
                        })
                    }
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        selectClick(val) {
            this.money = 0
            val.forEach(item => {
                var arr = this.sendDataInfo.psSettleInvoiceDetail.filter(val => val.dapdId == item.dapdId)
                if (arr.length == 0) {
                    this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
                }
            })
            this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
            })
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        setMoney(jurconfigform) {
            const index = jurconfigform.findIndex(
                (item) => item.entityField == "sxf"
            );
            if (index < 0) {
                return
            }
            if (jurconfigform[index].isShow) {
                this.$http.feeDeduction({
                    payMoney: this.sendDataInfo.payMoney,
                }).then((res) => {
                    if (res.status == 200) {
                        this.sendDataInfo.sxf = res.result;
                    }
                });
            }
        },
        //触发提取
        openExtSearch() {
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            console.log('提取', val);
            if (val != "" || val != undefined) {
                this.tableType = val.settleMode
                if (this.tableType == 1) {
                    for (let key in val) {
                        if (key == "psSettleInvoiceDetail") {
                            this.sendDataInfo.psSettleInvoiceDetail = val.psSettleInvoiceDetail;
                        } else {
                            this.sendDataInfo[key] = val[key];
                            this.sendDataInfo.totalMoney = 0
                            // this.sendDataInfo.totalNumber = 0
                            this.sendDataInfo.totalCount = 0
                        }
                    }
                    // this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                    // 	this.sendDataInfo.totalMoney += item.settleMoney
                    // 	// this.sendDataInfo.totalNumber += item.oldNum
                    // })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, val.totalMoney)
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                    this.DialogExtract = false;
                    this.getMoney()
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = 0
                        let refsElTable = this.$refs.mxTableRef2
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this.selectedDetailsIndex]);
                        this.nextFocus(0)
                    })
                } else {
                    for (let key in val) {
                        if (key == "psSettlerInvoice") {
                            this.sendDataInfo.psSettlerInvoice = val.psSettlerInvoice;
                        } else {
                            this.sendDataInfo[key] = val[key];
                            this.sendDataInfo.totalMoney = 0
                            // this.sendDataInfo.totalNumber = 0
                            this.sendDataInfo.totalCount = 0
                        }
                    }
                    // this.sendDataInfo.psSettlerInvoice.forEach(item => {
                    // 	this.sendDataInfo.totalMoney += item.settleMoney
                    // 	// this.sendDataInfo.totalNumber += item.oldNum
                    // })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, val.totalMoney)
                    // this.sendDataInfo.totalMoney=this.$common.getDecimalInfo(3,this.sendDataInfo.totalMoney)
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettlerInvoice.length
                    this.DialogExtract = false;
                    this.getMoney()
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = 0
                        let refsElTable = this.$refs.mxTableRef1
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this.selectedDetailsIndex]);
                        this.nextFocus(0)
                    })
                }
            }
        },
        async getMoney() {
            let sendData = {
                opmId: this.sendDataInfo.opmId,
                unitId: this.sendDataInfo.smId,
                salesId: this.sendDataInfo.salesId,
                coId: this.sendDataInfo.coId,
                ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId
            }
            var responseData = await this.$http.shipPlanAddLoading(sendData);
            if (responseData.status == 200) {
                let res = responseData.result
                this.sendDataInfo.noorderPrepaySum = res.noorderPrepaySum
                console.log(this.sendDataInfo.noorderPrepaySum)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        setPreMpney() {
            this.sendDataInfo.preMoney = Number(this.sendDataInfo.preMoney)
            this.sendDataInfo.totalMoney = Number(this.sendDataInfo.totalMoney)
            console.log(typeof this.sendDataInfo.preMoney, typeof this.sendDataInfo.noorderPrepaySum, typeof this.sendDataInfo.totalMoney)
            if (this.sendDataInfo.preMoney > this.sendDataInfo.noorderPrepaySum ||
                this.sendDataInfo.preMoney > this.sendDataInfo.totalMoney) {
                this.$message({
                    message: '使用预付金额不能超过预付余额或总付款金额',
                    type: 'warning'
                });
                this.sendDataInfo.preMoney = 0
            }
            this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney))
            this.$forceUpdate()
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
                    .printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        calculateTotal(e) {
            // console.log(e)
            if (this.tableType == 0 || e == 0 || this.tableType == 3) {
                addEventListener('keyup', this.keyUp1) //创建监听键盘事件
                removeEventListener('keyup', this.keyUp2)
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.psSettleInvoiceDetail = []
                this.sendDataInfo.totalCount = this.sendDataInfo.psSettlerInvoice.length
                if (this.sendDataInfo.psSettlerInvoice.length > 0) {
                    this.sendDataInfo.psSettlerInvoice.forEach(item => {
                        if (item.oldBalance > 0) {
                            if (item.settleMoney > item.oldBalance) {
                                item.settleMoney = item.oldBalance
                            } else if (item.settleMoney < 0) {
                                item.settleMoney = 0
                            }
                        } else if (item.oldBalance < 0) {
                            if (item.settleMoney < item.oldBalance) {
                                item.settleMoney = item.oldBalance
                            } else if (item.settleMoney > 0) {
                                item.settleMoney = 0
                            }
                        }
                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                            3,
                            NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
                        );
                    })
                }
            } else if (this.tableType == 1 || e == 1 || this.tableType == 2 || e == 2) {
                addEventListener('keyup', this.keyUp2) //创建监听键盘事件
                removeEventListener('keyup', this.keyUp1)
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.psSettlerInvoice = []
                // this.sendDataInfo.psSettleInvoiceDetail = []
                this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                if (this.sendDataInfo.psSettleInvoiceDetail.length > 0) {
                    this.sendDataInfo.psSettleInvoiceDetail.forEach((item, index) => {
                        if (this.selectedDataIndex1 == index) {
                            if (item.settleCount == '' || !item.settleCount == undefined) {
                                item.settleCount = 0
                            }
                        }

                        if (item.settleCount != item.oldBalancenum) {
                            item.settleMoney = this.$common.getDecimalInfo(
                                3,
                                NP.times(item.psprice, (item.settleCount || 0))
                            );
                        } else if (item.settleCount == item.oldBalancenum) {
                            item.settleMoney = item.oldBalance
                        }
                        if (item.settleMoney == 0 || item.settleCount == 0) {
                            item.settleMoney = ''
                            item.settleCount = ''
                        }
                        if (item.oldBalance > 0) {
                            if (item.settleMoney > item.oldBalance) {
                                item.settleMoney = item.oldBalance
                                item.settleCount = item.settleMoney / Number(item.psprice)
                            } else if (item.settleMoney < 0) {
                                item.settleMoney = 0
                                item.settleCount = 0
                            }
                            if (item.oldBalancenum < 0) {
                                if (item.settleCount < item.oldBalancenum) {
                                    item.settleMoney = item.oldBalance
                                    item.settleCount = item.oldBalancenum
                                }
                            } else {
                                if (item.settleCount > item.oldBalancenum) {
                                    item.settleMoney = item.oldBalance
                                    item.settleCount = item.oldBalancenum
                                }
                            }
                        } else if (item.oldBalance < 0) {
                            if (item.settleMoney < item.oldBalance) {
                                item.settleMoney = item.oldBalance
                                item.settleCount = item.settleMoney / Number(item.psprice)
                            } else if (item.settleMoney > 0) {
                                item.settleMoney = 0
                                item.settleCount = 0
                            }
                            if (item.oldBalancenum < 0) {
                                if (item.settleCount < item.oldBalancenum) {
                                    item.settleMoney = item.oldBalance
                                    item.settleCount = item.oldBalancenum
                                }
                            } else {
                                if (item.settleCount > item.oldBalancenum) {
                                    item.settleMoney = item.oldBalance
                                    item.settleCount = item.oldBalancenum
                                }
                            }
                        }

                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                            3,
                            NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
                        );
                    })
                    this.sendDataInfo.psSettleInvoiceDetail.splice(1, 0)
                }
            }
        },
        toMoney(index) {
            this.$forceUpdate()
            var info = this.sendDataInfo.psSettleInvoiceDetail[index]

            if (info.oldBalance > 0) {
                if (info.settleMoney > info.oldBalance) {
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleMoney = info.oldBalance
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleCount = info.oldBalancenum
                } else if (info.settleMoney < 0) {
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleMoney = 0
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleCount = 0
                }
            } else if (info.oldBalance < 0) {
                if (info.settleMoney < info.oldBalance) {
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleMoney = info.oldBalance
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleCount = info.oldBalancenum
                } else if (info.settleMoney > 0) {
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleMoney = 0
                    this.sendDataInfo.psSettleInvoiceDetail[index].settleCount = 0
                }
            }
            this.sendDataInfo.psSettleInvoiceDetail[index].settleCount = this.$common.getDecimalInfo(1, NP.divide(info.settleMoney, info.psprice))
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                    3,
                    NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
                );
            })
        },
        async getSelect(val) {
            console.log(val);
            this.sendDataInfo.totalMoney = 0
            this.DialogVisible1 = false
            if (this.seId == 8820873997127713) {
                var mx = this.$refs.searchScheme.multipleSelection
                this.sendDataInfo.psSettlerInvoice = []
                if (this.sendDataInfo.psSettleInvoiceDetail.length == 0) {
                    this.sendDataInfo.psSettleInvoiceDetail = mx
                } else {
                    this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                        mx.forEach((item1, index1) => {
                            if (item1.businessId == item.businessId) {
                                mx.splice(index1, 1)
                            }
                        })
                    })
                    this.sendDataInfo.psSettleInvoiceDetail = this.sendDataInfo.psSettleInvoiceDetail.concat(mx)
                }
                var sum = 0
                this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                    this.$set(item, 'settleMoney', Number(item.oldBalance))
                    this.$set(item, 'settleCount', Number(item.oldBalancenum))
                    sum += Number(item.oldBalance)
                })
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                this.$nextTick(() => {
                    addEventListener('keyup', this.keyUp2)
                    this.selectedDataIndex1 = 0
                    let refsElTable = this.$refs.mxTableRef2
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this.selectedDataIndex1]);
                    this.tableNextFocus2('settleCount', 0)
                })
                this.DialogVisible = false
            } else if (this.tableType == 0 || this.tableType == 3) {
                console.log(val,this.tableType);
                var mx = val.mainData
                if(this.tableType == 0){
                    this.dialogList = []
                    let flag = -1;
                    try {
                        const res = await this.$http.checkPaymentCreditPeriod({
                            psSettleApplyDetail: val.mainData
                        });
                        if (res && res.status == 200) {
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag != -1) {
                                return;
                            }
                        } else {
                            this.lineMessageBox(res);
                            return;
                        }
                    } catch (rej) {
                        this.lineMessageBox(rej);
                        return;
                    }
                }
                this.sendDataInfo.psSettleInvoiceDetail = []
                if (this.sendDataInfo.psSettlerInvoice.length == 0) {
                    this.sendDataInfo.psSettlerInvoice = mx
                } else {
                    this.sendDataInfo.psSettlerInvoice.forEach(item => {
                        mx.forEach((item1, index1) => {
                            if (item1.businessId == item.businessId) {
                                mx.splice(index1, 1)
                            }
                        })
                    })
                    this.sendDataInfo.psSettlerInvoice = this.sendDataInfo.psSettlerInvoice.concat(mx)
                }
                var sum = 0
                this.sendDataInfo.psSettlerInvoice.forEach(item => {
                    this.$set(item, 'settleMoney', Number(item.oldBalance))
                    sum += Number(item.oldBalance)
                })
                this.sendDataInfo.totalCount = this.sendDataInfo.psSettlerInvoice.length
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                this.$nextTick(() => {
                    addEventListener('keyup', this.keyUp1) //创建监听键盘事件
                    this.selectedDataIndex = 0
                    let refsElTable = this.$refs.mxTableRef1
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                        .selectedDataIndex]);
                    this.tableNextFocus1('settleMoney', 0)
                })
            } else if (this.tableType == 1 || this.tableType == 2) {
                var mx = this.$refs.searchSchemeMultiple.multipleSelection
                this.sendDataInfo.psSettlerInvoice = []
                console.log(this.sendDataInfo.psSettleInvoiceDetail);
                if (this.sendDataInfo.psSettleInvoiceDetail.length == 0) {
                    this.sendDataInfo.psSettleInvoiceDetail = mx
                } else {
                    this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                        mx.forEach((item1, index1) => {
                            if (item1.businessId == item.businessId) {
                                mx.splice(index1, 1)
                            }
                        })
                    })
                    this.sendDataInfo.psSettleInvoiceDetail = this.sendDataInfo.psSettleInvoiceDetail.concat(mx)
                }
                var sum = 0
                this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                    this.$set(item, 'settleMoney', Number(item.oldBalance))
                    this.$set(item, 'settleCount', Number(item.oldBalancenum))
                    sum += Number(item.oldBalance)
                })
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                this.$nextTick(() => {
                    addEventListener('keyup', this.keyUp2) //创建监听键盘事件
                    this.selectedDataIndex1 = 0
                    let refsElTable = this.$refs.mxTableRef2
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                        .selectedDataIndex1]);
                    this.tableNextFocus2('settleCount', 0)
                })
            }
        },
        extract(sendDataInfo) {
            // return
            this.money = 0
            this.extractParamsData = { ...this.sendDataInfo }
            removeEventListener('keyup', this.keyUp1)
            removeEventListener('keyup', this.keyUp2)
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.parentData.list = []
                    if (this.tableType == 0 || this.tableType == 3) {
                        this.searchId = '610674495066112'
                        if (this.sendDataInfo.psSettlerInvoice.length > 0) {
                            this.parentData.type = 'dapmId'
                            this.parentData.type1 = 'businessId'
                            this.parentData.list = this.sendDataInfo.psSettlerInvoice
                        }
                    } else if (this.tableType == 1) {
                        this.searchId = '614769050128384'
                        if (this.sendDataInfo.psSettleInvoiceDetail.length > 0) {
                            this.parentData.type = 'dapdId'
                            this.parentData.type1 = 'businessId'
                            this.parentData.list = this.sendDataInfo.psSettleInvoiceDetail
                            this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                                this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
                            })
                        }
                    } else if (this.tableType == 2) {
                        this.searchId = '614770750128385'
                        if (this.sendDataInfo.psSettleInvoiceDetail.length > 0) {
                            this.parentData.type = 'dasdId'
                            this.parentData.type1 = 'businessId'
                            this.parentData.list = this.sendDataInfo.psSettleInvoiceDetail
                            this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                                this.money = this.$common.getDecimalInfo(3, NP.plus(item.psmoney, this.money))
                            })
                        }
                    }
                    this.DialogVisible1 = true
                } else {
                    this.$message.error('请完善必填项')
                }
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp1) //创建监听键盘事件
                addEventListener('keyup', this.keyUp2) //创建监听键盘事件
                this.paramValue(val)
                if (this.seType == 'smName') {
                    if (this.sendDataInfo.smName != val.smName) {
                        this.sendDataInfo.salesName = ''
                        this.sendDataInfo.salesId = ''
                        this.parentSearchData1.salesId = ''
                    }
                    this.parentSearchData.smId = val.smId
                    this.parentSearchData1.smId = val.smId
                    this.sendDataInfo.smName = val.smName;
                    this.sendDataInfo.smId = val.smId;
                    this.$http.queryDefaultSales({
                        ids: [val.smId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            var valObj = {
                                ...val,
                                ...res.result,
                            }
                            if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                this.$http.checkSalesLicense({
                                    //校验供应商业务员
                                    formId: this.formDataList[0].jciId, //表单ID
                                    salesId: valObj.salesId, //业务员ID
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        let flag = -1;
                                        if (res.result != null && res.result.length > 0) {
                                            res.result.forEach(item => {
                                                this.dialogList.push(item)
                                            })
                                            flag = this.dialogList.findIndex(
                                                (item) => item.level == 0
                                            );
                                            this.showDialog = true;
                                        }
                                        if (flag == -1) {
                                            this.paramValue(valObj);
                                        }
                                    } else {
                                        this.lineMessageBox(res);

                                        return false;
                                    }
                                }).catch((rej) => {
                                    this.lineMessageBox(rej);
                                });
                            } else {
                                this.paramValue(val);
                            }
                        } else {
                            this.paramValue(val);
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                    });
                } else if (this.seType == 'salesName') {
                    this.parentSearchData1.salesId = val.salesId
                } else if (this.seType == 'opmName') {
                    this.parentSearchData1.opmId = val.opmId
                } else if (this.seType == 'coName') {
                    this.parentSearchData1.coId = val.coId
                } else if (this.seType == 'sbiAddress') {
                    this.parentSearchData.smId = val.smId
                } else if (this.seType == 'depName') {
                    this.parentSearchData1.depId = val.depId
                } else if (this.seId == 8820873997127713) {
                    var mx = JSON.parse(JSON.stringify(val))
                    this.sendDataInfo.psSettlerInvoice = []
                    console.log(this.sendDataInfo.psSettleInvoiceDetail);
                    if (this.sendDataInfo.psSettleInvoiceDetail.length == 0) {
                        this.sendDataInfo.psSettleInvoiceDetail = mx
                    } else {
                        this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                            mx.forEach((item1, index1) => {
                                if (item1.businessId == item.businessId) {
                                    mx.splice(index1, 1)
                                }
                            })
                        })
                        this.sendDataInfo.psSettleInvoiceDetail = this.sendDataInfo.psSettleInvoiceDetail.concat(mx)
                    }
                    var sum = 0
                    this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                        this.$set(item, 'settleMoney', Number(item.oldBalance))
                        this.$set(item, 'settleCount', Number(item.oldBalancenum))
                        sum += Number(item.oldBalance)
                    })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                    this.$nextTick(() => {
                        addEventListener('keyup', this.keyUp2) //创建监听键盘事件
                        this.selectedDataIndex1 = 0
                        let refsElTable = this.$refs.mxTableRef2
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                            .selectedDataIndex1]);
                        this.tableNextFocus2('settleCount', 0)
                    })
                } else if (this.seId == 8820873997127716) {
                    var mx = JSON.parse(JSON.stringify(val))
                    this.sendDataInfo.psSettleInvoiceDetail = []
                    if (this.sendDataInfo.psSettlerInvoice.length == 0) {
                        this.sendDataInfo.psSettlerInvoice = mx
                    } else {
                        this.sendDataInfo.psSettlerInvoice.forEach(item => {
                            mx.forEach((item1, index1) => {
                                if (item1.businessId == item.businessId) {
                                    mx.splice(index1, 1)
                                }
                            })
                        })
                        this.sendDataInfo.psSettlerInvoice = this.sendDataInfo.psSettlerInvoice.concat(mx)
                    }
                    var sum = 0
                    this.sendDataInfo.psSettlerInvoice.forEach(item => {
                        this.$set(item, 'settleMoney', Number(item.oldBalance))
                        sum += Number(item.oldBalance)
                    })
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettlerInvoice.length
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, sum)
                    this.$nextTick(() => {
                        addEventListener('keyup', this.keyUp1) //创建监听键盘事件
                        this.selectedDataIndex = 0
                        let refsElTable = this.$refs.mxTableRef1
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                            .selectedDataIndex]);
                        this.tableNextFocus1('settleMoney', 0)
                    })
                }
            }
        },
        //换行提示
        lineMessageBox(data) {
            let msg = (data && data.message) ? data.message : (typeof data === 'string' ? data : '操作失败');
            let txtArr = msg.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                this.$nextTick(() => {
                    this.extract('sendDataInfo')
                })
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus2(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.psSettleInvoiceDetail.length - 1) return
                if (this.sendDataInfo.psSettleInvoiceDetail[index + 1] != undefined) {
                    this.selectedDataIndex1 = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef2
                        this.$refs['settleMoney'][index + 1].focus() //跳退货数量
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                            .selectedDataIndex1]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 表格切换焦点方法
        tableNextFocus1(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.psSettlerInvoice.length - 1) return
                if (this.sendDataInfo.psSettlerInvoice[index + 1] != undefined) {
                    this.selectedDataIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef1
                        this.$refs['settleMoney'][index + 1].focus() //跳退货数量
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                            .selectedDataIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            if (type == 'salesName' || type == 'sbiAddress') {
                // console.log('openSearch', this.sendDataInfo.smId);
                if (this.sendDataInfo.smId) this.parentSearchData.smId = this.sendDataInfo.smId;
                if (this.parentSearchData.smId == '') {
                    return this.$message({
                        message: '请先选择供应商',
                        type: 'warning'
                    });
                }
            }
            removeEventListener('keyup', this.keyUp1)
            removeEventListener('keyup', this.keyUp2)
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            this.oneFlag = false
            this.parentSearchData[type] = this.sendDataInfo[type]
            if (sId == 8820873997127713) {
                if (this.sendDataInfo.smId == '') {
                    return this.$message({
                        message: '请先选择供应商',
                        type: 'warning'
                    });
                } else if (this.sendDataInfo.coId == '') {
                    return this.$message({
                        message: '请先选择货主',
                        type: 'warning'
                    });
                }
                this.tableType = 1
                this.parentSearchData.smId = this.sendDataInfo.smId;
                this.parentSearchData.coId = this.sendDataInfo.coId
                this.oneFlag = true
            } else if (sId == 8820873997127716) {
                if (this.sendDataInfo.smId == '') {
                    return this.$message({
                        message: '请先选择供应商',
                        type: 'warning'
                    });
                } else if (this.sendDataInfo.coId == '') {
                    return this.$message({
                        message: '请先选择货主',
                        type: 'warning'
                    });
                }
                this.tableType = 3
                this.parentSearchData.smId = this.sendDataInfo.smId;
                this.parentSearchData.coId = this.sendDataInfo.coId
                this.oneFlag = true
            }
            this.DialogVisible = true;
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            console.log(this.form);
            const arrList = [
                {
                    id: 'coId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'coName')].isShow
                }, {
                    id: 'smId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'smName')].isShow
                }, {
                    id: 'opmId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'opmName')].isShow
                }, {
                    id: 'salesId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'salesName')].isShow
                }].filter(item => item.value).map(item => 'this.sendDataInfo.' + item.id + " != ''")
            this.$nextTick(() => {
                console.log(arrList.join('&&'));
                if (eval(arrList.join('&&'))) {
                    this.getMoney()
                }
                this.nextFocus(this.seIndex)
            })
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            row.index = rowIndex;
        },
        detailsAction(cate = 0) {
            if (cate == 0) {
                this.editDateilsIndex = ""
                return false
            }

            var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
            if (dataInfo.psodPacknum <= 0) {
                this.$message({
                    message: '请填写采购数量',
                    type: 'error'
                });
                return false
            }
            if (this.editDateilsIndex !== "") {
                this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1)
            }
            this.sendDataInfo.pisOrderDetail.push(dataInfo)
            // console.log('this.sendDataInfo.pisOrderDetail',this.sendDataInfo.pisOrderDetail)
            this.editDateilsIndex = ""
            this.detailsBox.status = false
        },
        initActionBox(sendDataInfo) {
            this.$confirm('确定取消新增吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('drawerCancel')
                this.init()
                this.$refs.sendDataInfo.resetFields();
            }).catch(() => { });

        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'pisOrderAuxinf') {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = ''
                    }
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
            this.sendDataInfo.dpsmDate = this.$moment().valueOf();
            this.sendDataInfo.psSettleInvoiceDetail = []
            this.sendDataInfo.psSettlerInvoice = []
            this.sendDataInfo.isWms = 0
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
            this.sendDataInfo.preMoney = 0
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach(item => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.psomBusdept = item.depId
                }
            })
        },
        async isShowData(name, value) {
            switch (name) {
                case 'supplier':
                    var dataInfo = sessionStorage.getItem('selectSupplierData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.smId = dataInfo.smId
                        this.sendDataInfo.smName = dataInfo.smName

                    }
                    this.sendDataInfo.salesId = ''
                    this.getUnitSalesmanList()
                    break;
                case 'cargoOwner':
                    var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName
                    }
                    break;
            }
        },
        selectDataAction(data) {
            this.detaislDataInfo = {
                // "bgmId":data.bgmId,
                "bgmId": data.bgmId,
                "bgmName": data.bgmName,
                "inRate": data.bgfIntaxrate,
                bgmManufacturer: data.bgmManufacturer,
                bgmSpecifications: data.bgmSpecifications,
                bgmPlaceorigin: data.bgmPlaceorigin,
                "money": 0,
                "psodPacknum": 0,
                "price": 0,
                "psodPsdvolume": 0,
                "psodPslowerlimit": 0,
                "psmoney": 0,
                "psodPsnvolume": 0,
                "psprice": 0,
                "psodPsupperlimit": 0,
                "pspmId": '',
                "stId": data.stId,
                "pspdId": '',
                "psodReserves1": "",
                "psodReserves2": "",
                "psodReserves3": "",
                "psodReserves4": "",
                "psodReserves5": "",
                "psodReserves6": "",
            }
            this.selectDataTable = false
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });

        },
        openBox(cate, formData, mainId, oldData = '') {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            if (this.actionData.form) {

                this.form = this.actionData.form
            }
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                for (let key in this.parentSearchData) {
                    this.parentSearchData[key] = ''
                }
                this.initDefaultValue();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
                this.tableType = this.sendDataInfo.settleMode
                this.smId = dataInfo.smId
                this.getUnitSalesmanList()
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
                this.tableType = this.sendDataInfo.settleMode
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 100)
            })

        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub(sendDataInfo)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        async sub(sendDataInfo) {
            if (this.tableType == 0 || this.tableType == 3) {
                this.sendDataInfo.settleMode = this.tableType
                var data1 = []
                this.sendDataInfo.psSettlerInvoice.forEach(item => {
                    data1.push({
                        businessId: item.businessId || null,
                        businessType: item.businessType || null,
                        dapdId: item.dapdId || null,
                        dapmId: item.dapmId || null,
                        isDetail: item.isDetail,
                        oldBalance: item.oldBalance || 0,
                        oldBalancenum: item.oldBalancenum || 0,
                        settleCount: item.settleCount || 0,
                        settleMoney: item.settleMoney || 0,
                    })
                })
                this.sendDataInfo.psSettleApplyDetail = data1
            } else {
                this.sendDataInfo.settleMode = this.tableType
                var data2 = []
                this.sendDataInfo.psSettleInvoiceDetail.forEach(item => {
                    data2.push({
                        dapdId: item.dapdId,
                        dapmId: item.dapmId,
                        oldBalance: item.oldBalance,
                        settleMoney: item.settleMoney,
                        settleCount: item.settleCount,
                        oldBalancenum: item.oldBalancenum,
                        businessId: item.businessId || "",
                        businessType: item.businessType || "",
                    })
                })
                this.sendDataInfo.psSettleApplyDetail = data2
            }
            if (this.sendDataInfo.psSettleApplyDetail.some((val) => val.settleMoney == 0 || val.settleMoney == "")) {
                this.$message({
                    type: "error",
                    message: "明细付款金额不能为0或者空",
                });
                return;
            } else {
                var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
                delete sendData.psSettleInvoiceDetail
                delete sendData.psSettlerInvoice
                var responseData = await this.$http.addPsSettlementApply(this.sendDataInfo)
                if (responseData.status == 200) {
                    this.init()
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.$emit('drawerCancel')
                    this.$refs.sendDataInfo.resetFields();

                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }
        },
        deleteDetails() {
            if (this.tableType == 0 || this.tableType == 3) {
                if (this.sendDataInfo.psSettlerInvoice.length > 0) {
                    this.sendDataInfo.psSettlerInvoice.splice(this.selectedDataIndex, 1)
                    this.selectedDataIndex = 0
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettlerInvoice.length
                } else {
                    return this.$message({
                        message: '暂无可删除明细',
                        type: 'warning'
                    })
                }
            } else if (this.tableType == 1 || this.tableType == 2) {
                if (this.sendDataInfo.psSettleInvoiceDetail.length > 0) {
                    this.sendDataInfo.psSettleInvoiceDetail.splice(this.selectedDataIndex1, 1)
                    this.selectedDataIndex1 = 0
                    this.sendDataInfo.totalCount = this.sendDataInfo.psSettleInvoiceDetail.length
                } else {
                    return this.$message({
                        message: '暂无可删除明细',
                        type: 'warning'
                    })
                }
            }
        },
        // 获取业务员
        async getUnitSalesmanList() {

            this.salesmanList = []
            let responseData = await this.$http.getUnitSalesmanList({
                ids: [this.sendDataInfo.smId]
            })
            if (responseData.status == 200) {
                this.salesmanList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取供货员
        async getSpecialUser() {

            let responseData = await this.$http.getSpecialUser({
                opmBuyer: 1
            })
            if (responseData.status == 200) {
                this.userOneList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21]
            })
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom()
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            var mxFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    mxFormList.push(item);
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            this.djForm = mxFormList[0].jurconfigform;
            this.mxForm = mxFormList[1].jurconfigform;
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "psSettlerInvoice" }, { entityField: "psSettleInvoiceDetail" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "dpsmDate", this.$moment().valueOf())
            this.$set(this.sendDataInfo, "isWms", 0)
        },
        // 判断是不是采购员
        checkIsBuyer() {
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmBuyer == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
                this.tabForm[0].jurconfigform.forEach(item => {
                    if (item.entityField == 'opmName') item.isChange = 0
                })
            }
        },
        // 监听键盘事件
        keyUp1(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.psSettlerInvoice.length == 0) return
                let refsElTable = this.$refs.mxTableRef1
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDataIndex = 0
                    } else if (this.selectedDataIndex == this.sendDataInfo.psSettlerInvoice.length -
                        1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDataIndex = 0
                    } else { // 正常递增
                        this.selectedDataIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this
                        .selectedDataIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                            .selectedDataIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                        .selectedDataIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.psSettlerInvoice.length == 0) return
                let refsElTable = this.$refs.mxTableRef1
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDataIndex = 0
                    } else if (this.selectedDataIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDataIndex = this.sendDataInfo.psSettlerInvoice.length - 1
                    } else { // 正常递减
                        this.selectedDataIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this
                        .selectedDataIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                            .selectedDataIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettlerInvoice[this
                        .selectedDataIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp1) //创建监听键盘事件
        },
        // 表格方法
        rowClassName1({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
        },

        // 明细表格点击选中
        clickEvent1(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef1; // 获取表格对象
            let findRow = {}
            this.selectedDataIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange1(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

        // 监听键盘事件
        keyUp2(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                // this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.psSettleInvoiceDetail.length == 0) return
                let refsElTable = this.$refs.mxTableRef2
                this.$nextTick(() => {
                    if (this.selectedRow2.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDataIndex1 = 0
                    } else if (this.selectedDataIndex1 == this.sendDataInfo.psSettleInvoiceDetail.length -
                        1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDataIndex1 = 0
                    } else { // 正常递增
                        this.selectedDataIndex1++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow2.find(c => c.rowIndex == this
                        .selectedDataIndex1); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow2.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                            .selectedDataIndex1], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                        .selectedDataIndex1]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.psSettleInvoiceDetail.length == 0) return
                let refsElTable = this.$refs.mxTableRef2
                this.$nextTick(() => {
                    if (this.selectedRow2.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDataIndex1 = 0
                    } else if (this.selectedDataIndex1 == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDataIndex1 = this.sendDataInfo.psSettleInvoiceDetail.length - 1
                    } else { // 正常递减
                        this.selectedDataIndex1--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow2.find(c => c.rowIndex == this
                        .selectedDataIndex1); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow2.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                            .selectedDataIndex1], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.psSettleInvoiceDetail[this
                        .selectedDataIndex1]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp) //创建监听键盘事件
        },
        // 表格方法
        rowClassName2({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow2.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
        },

        // 明细表格点击选中
        clickEvent2(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef2; // 获取表格对象
            let findRow = {}
            this.selectedDataIndex1 = row.rowIndex
            findRow = this.selectedRow2.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow2.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange2(rows) {
            this.selectedRow2 = rows; // 保存已选择行
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
            this.invoiceShow = window.global_config.extendShow ? true : false
            // this.checkIsBuyer()
        })
        this.getSpecialUser()
        this.getUnitSalesmanList()
        this.getPartDictionariesData()
        this.getAllStorageRoom()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        addEventListener('keyup', this.keyUp1) //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp1)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.flex {
    display: flex;
    align-items: center;
}
</style>